<div class="bls-wrap">

  <!-- ── Header ─────────────────────────────────────────────── -->
  <header class="bls-header">
    <div>
      <h1 class="bls-title">Binance Link · Creación de sub-cuentas</h1>
      <p class="bls-subtitle">Consulta usuarios elegibles y genera sub-cuentas, de a una o en lote.</p>
    </div>
    <div class="bls-kpis" *ngIf="aggregates as a">
      <div class="kpi"><span class="kpi-n">{{ a.totalActive }}</span><span class="kpi-l">Wallets activas</span></div>
      <div class="kpi"><span class="kpi-n">{{ a.createdToday }}</span><span class="kpi-l">Creadas hoy</span></div>
      <div class="kpi"><span class="kpi-n">{{ a.byWalletStatus.KYC_PENDING || 0 }}</span><span class="kpi-l">KYC pendiente</span></div>
      <div class="kpi kpi-err" *ngIf="a.errorCount"><span class="kpi-n">{{ a.errorCount }}</span><span class="kpi-l">Con error</span></div>
    </div>
  </header>

  <!-- ── Filtros ────────────────────────────────────────────── -->
  <div class="bls-filters">
    <div class="bls-search">
      <mat-icon>search</mat-icon>
      <input type="text" placeholder="Buscar por email, nombre, RUT o razón social…"
        [value]="filterQ" (input)="onSearchChange($any($event.target).value)" />
    </div>
    <div class="bls-seg">
      <button [class.active]="filterHasWallet === 'without'" (click)="onFilterHasWalletChange('without')">Elegibles</button>
      <button [class.active]="filterHasWallet === 'with'" (click)="onFilterHasWalletChange('with')">Con wallet</button>
      <button [class.active]="filterHasWallet === 'all'" (click)="onFilterHasWalletChange('all')">Todos</button>
    </div>
  </div>

  <!-- ── Barra de selección ─────────────────────────────────── -->
  <div class="bls-selbar" *ngIf="selectedCount > 0">
    <span class="sel-count">{{ selectedCount }} seleccionado(s)</span>
    <span class="sel-hint" *ngIf="selectedCount > BATCH_MAX">Máximo {{ BATCH_MAX }} por lote</span>
    <span class="sel-spacer"></span>
    <button class="btn-ghost" (click)="clearSelection()">Limpiar</button>
    <button class="btn-primary" [disabled]="batchRunning || selectedCount > BATCH_MAX" (click)="crearSeleccionadas()">
      Crear seleccionadas ({{ selectedCount }})
    </button>
  </div>

  <!-- ── Panel de progreso del lote ─────────────────────────── -->
  <div class="bls-batch" *ngIf="batch as b">
    <div class="batch-top">
      <span class="batch-title">
        <mat-icon [class.spin]="batchRunning">{{ batchRunning ? 'autorenew' : (b.status === 'completed' ? 'check_circle' : 'error') }}</mat-icon>
        Lote {{ batchRunning ? 'en curso' : (b.status === 'completed' ? 'completado' : 'con fallas') }}
      </span>
      <span class="batch-counts">
        <b>{{ b.processed }}</b> / {{ b.total }}
        · <span class="ok">{{ b.ok }} ok</span>
        <span *ngIf="b.errors"> · <span class="err">{{ b.errors }} error(es)</span></span>
      </span>
      <button class="batch-close" *ngIf="!batchRunning" (click)="cerrarPanelLote()" aria-label="Cerrar"><mat-icon>close</mat-icon></button>
    </div>
    <div class="batch-bar"><div class="batch-fill" [style.width.%]="batchProgressPct"></div></div>

    <div class="batch-errors" *ngIf="!batchRunning && batchErrors.length">
      <div class="batch-errors-head">
        <span>Fallidos ({{ batchErrors.length }})</span>
        <button class="btn-link" (click)="reintentarFallidos()">Reintentar solo estos</button>
      </div>
      <ul>
        <li *ngFor="let r of batchErrors">
          <span class="mono">#{{ r.usuarioId }}</span> — {{ r.error || 'error desconocido' }}
        </li>
      </ul>
    </div>
  </div>

  <!-- ── Tabla ──────────────────────────────────────────────── -->
  <div class="bls-table-scroll">
    <table class="bls-table">
      <thead>
        <tr>
          <th class="c-check">
            <input type="checkbox" [checked]="allPageSelected" (change)="toggleSelectAllPage()"
              [disabled]="selectablePageEmpty" aria-label="Seleccionar todos de la página" />
          </th>
          <th>Usuario</th>
          <th>RUT</th>
          <th class="c-kyc">KYC</th>
          <th>Prevalidación</th>
          <th>Wallet</th>
          <th class="c-acc">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let u of users; trackBy: trackByUser" [class.row-sel]="isSelected(u)">
          <td class="c-check">
            <input type="checkbox" [checked]="isSelected(u)" (change)="toggleSelect(u)"
              [disabled]="!isSelectable(u)" [attr.aria-label]="'Seleccionar ' + userLabel(u)" />
          </td>
          <td>
            <div class="u-name">{{ userLabel(u) }}</div>
            <div class="u-mail">{{ u.email }}</div>
          </td>
          <td class="mono">{{ rut(u) }}</td>
          <td class="c-kyc">
            <span class="kyc-chips" [title]="kyc(u).completo ? 'KYC completo' : 'KYC incompleto'">
              <span class="chip" [class.on]="kyc(u).frontal">Front</span>
              <span class="chip" [class.on]="kyc(u).posterior">Pos</span>
              <span class="chip" [class.on]="kyc(u).selfie">Selfie</span>
              <span class="chip" [class.on]="kyc(u).datos">Datos</span>
            </span>
          </td>
          <td><span class="badge" [ngClass]="prevalBadge(u).cls">{{ prevalBadge(u).label }}</span></td>
          <td><span class="badge" [ngClass]="walletBadge(u).cls">{{ walletBadge(u).label }}</span></td>
          <td class="c-acc">
            <button *ngIf="isSelectable(u)" class="btn-sm btn-primary" (click)="crearIndividual(u)">Crear</button>
            <ng-container *ngIf="!isSelectable(u)">
              <button class="btn-sm" (click)="verDetalle(u)">Detalle</button>
              <button class="btn-sm" *ngIf="u.walletStatus === 'KYC_PENDING'" (click)="enviarKyc(u)">Enviar KYC</button>
              <button class="btn-sm" *ngIf="u.walletStatus === 'ACTIVE' && u.kycStatus === 'PASS' && !u.walletTrc20" (click)="generarTrc20(u)">TRC20</button>
              <button class="btn-sm btn-danger" (click)="deshabilitar(u)">Deshabilitar</button>
            </ng-container>
          </td>
        </tr>

        <tr *ngIf="!loading && users.length === 0">
          <td colspan="7" class="empty">No hay usuarios para el filtro actual.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ── Paginación ─────────────────────────────────────────── -->
  <div class="bls-pager" *ngIf="totalItems > 0">
    <span class="pg-range">{{ rangeFrom }}–{{ rangeTo }} de {{ totalItems }}</span>
    <span class="sel-spacer"></span>
    <button class="pg-btn" [disabled]="currentPage <= 1" (click)="goToPage(currentPage - 1)"><mat-icon>chevron_left</mat-icon></button>
    <span class="pg-page">{{ currentPage }} / {{ totalPages }}</span>
    <button class="pg-btn" [disabled]="currentPage >= totalPages" (click)="goToPage(currentPage + 1)"><mat-icon>chevron_right</mat-icon></button>
  </div>

</div>
